import { ChangeEvent } from 'react'

const digitRegex = /^\d*$/

export const noSpecialCharsRegex = /^[a-zA-Z0-9 ]*$/
const noSpecialCharsRegexWithHindi = /^[a-zA-Z0-9\u0900-\u097F ]*$/

export const validateDigitOnly = (value: string): boolean => {
  return digitRegex.test(value)
}

export const withSpecialCharFilter = (
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void,
  allowHindiChars = false,
) => {
  return onChange
    ? (e: ChangeEvent<HTMLInputElement>) => {
        const regex = allowHindiChars
          ? noSpecialCharsRegexWithHindi
          : noSpecialCharsRegex

        if (regex.test(e.target.value)) {
          onChange(e)
        }
      }
    : undefined
}
